import axios from 'axios'
import { useUserStore } from '@/store/user'
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()

let count = 0;
// axios interceptors management

/**
 * axios 호출 기본 설정
 * @param {String} baseURL api 호출 공통 url
 * @param {number} timeout 호출 제한 시간 10000 => 10초
 * @param {Map} headers  헤더값
 */
const instance = axios.create({

    baseURL : process.env.VUE_APP_API_URL,
    timeout: 10000,
    headers: {
        "Context-Type": "application/json;charset=utf-8",
    }
  });

/*
    api 호출 전 실행 함수
*/
instance.interceptors.request.use(
    function (config) {
        console.log('??')
        // 요청 바로 직전
        const userStore = useUserStore()

        if(userStore.getToken){
            config.headers['EZTOBIZ-AUTH-TOKEN'] = userStore.getToken
        }
        if(config.url == '/user/login'){
            config.baseURL = process.env.VUE_APP_API_AUTH_URL
        }

        count++;
        setIsLoading(true);
        return config
    }, 

    function (error) {
        // 요청 에러 처리를 작성합니다.
        count = count -1;
        if(count === 0) setIsLoading(false);
        return Promise.reject(error);
    }
);



/*
    api 호출 후 실행 함수
*/
instance.interceptors.response.use(
    function (response) {
    /*
        http status 200인 경우
        응답 바로 직전에 대해 작성합니다. 
        .then() 으로 이어집니다.
    */
   
        count = count -1;
        // if(count === 0) setIsLoading(false);

        return response
    },


    function (error) {
    /*
        http status가 200이 아닌 경우
        응답 에러 처리를 작성합니다.
        .catch() 으로 이어집니다.    
    */
        // if(error.response.status == 401){
        //     alert('토큰 에러')
        // }
        
        if(error && error.response && error.response?.data ){
            if(error.response.data?.code == '0401'){
                // alert('UNAUTHORIZED ERROR => 다시 로그인해주세요.')
                sessionStorage.removeItem('accessToken')
                return
            }
        }
        count = count -1;
        // if(count === 0) setIsLoading(false);
        return Promise.reject(error);
    }
);

// 생성한 인스턴스를 익스포트 합니다.
export default instance;